import React from 'react';
import Link from '../../../../base/Link/Link';
import { HeaderNavLinkStoryblok } from '../../../../types/storyblok';
import { Box } from '../../../../base/Box/Box';
import classNames from 'classnames';

export const HeaderNavLink = ({
  title,
  link,
  variant,
  className,
}: HeaderNavLinkStoryblok) => {
  return (
    <Box as="li" className={classNames(className, 'z-50')}>
      <Link
        href={link}
        className={variant !== 'primary' && 'text-p3'}
        variant={variant == 'primary' && 'primary'}
      >
        {title}
      </Link>
    </Box>
  );
};

export default HeaderNavLink;
